import gql from 'graphql-tag';

export const GET_TMP_MEMBER_INFO = gql`
  query($tmp_member_no: String!) {
    GetTmpMemberInfo(
      tmp_member_no: $tmp_member_no
    ){
      tmp_member_no
      full_name
    }
  }
`;
